import React, { useState, useImperativeHandle, forwardRef } from "react"
import { AntDesign } from "@expo/vector-icons"
import * as Animatable from 'react-native-animatable'
import { H5, Label, Separator, XStack, YStack } from "tamagui";
import styles from "@stylesheet";

type ExpandableSectionProps = {
  children: React.ReactNode;
  /**
 * @property defaultState - Optional. The initial expanded/collapsed state of the section. Defaults to `false`.
 */
  defaultState?: boolean;
  /**
* @property caretColor - Optional. The color of the caret icon used to toggle the section.
*/
  caretColor?: string;
  /*
  * @property textColor - Optional. The color of the text displayed in the section.
  **/
  textColor?: string;
  /**
  * @property title - Optional. The title displayed for the expandable section.
  */
  title?: string;
  /**
   * * @property caption - Optional. A caption or subtitle displayed below the title.
   */
  caption?: string;
  /**
   * @property openCallback - Optional. A callback function triggered when the section is toggled.
   */
  openCallback?: (open: boolean) => void;
}

const ExpandableSection = forwardRef<ExpandableSectionHandle, ExpandableSectionProps>((props, ref) => {
  const [open, setOpen] = useState(props.defaultState || false);
  const [height, setHeight] = useState(0);

  useImperativeHandle(ref, () => ({
    setHeight: (newHeight: number) => {
      setHeight(newHeight);
    },
    setOpen: (newOpen: boolean) => {
      setOpen(newOpen);
    },
    toggleOpen: () => {
      setOpen(!open);
    },
    getOpen: () => {
      return open;
    },
    getHeight: () => {
      return height;
    }
  }));

  return (
    <YStack>
      <XStack flex={1} gap={20}>
        <YStack flex={1}>
          <H5 fontWeight={'bold'} flex={3}>
            {props.title}
          </H5>
          <Label size="$2" color={props.textColor || "rgb(90,192,234)"}>{props.caption}</Label>
        </YStack>
        <AntDesign name={!open ? "caret-down" : "caret-up"} size={24} color={props.caretColor || "rgb(90,192,234)"} style={styles.centerEverything} onPress={() => {
          setOpen(!open); 
          setHeight(open ? 0 : 400);
        }} />
      </XStack>
      <Animatable.View transition={['minHeight', 'opacity']} style={{ paddingHorizontal: 10, overflow: 'hidden', minHeight: open? height : 0, opacity: open ? 1 : 0 }}>
        { open && props.children}
      </Animatable.View>
      <Separator/>
    </YStack>
  )
})
export default ExpandableSection